import { createElement } from 'react'

const logo = require('./logo.svg')

export function Logo({ className }: { className: string }) {
  return createElement('img', { 'data-test': 'logo', className, src: logo })
}

export default Logo
